import { Outlet } from 'react-router-dom';
import TopBar from '../components/common/TopBar.jsx';
import Header from '../components/common/Header.jsx';
import Navbar from '../components/common/Navbar.jsx';
import Footer from '../components/common/Footer.jsx';

// Auth pages share the public site chrome so users stay oriented while signing in.
export default function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col overflow-x-hidden">
      <TopBar />
      <Header />
      <Navbar />
      <main className="flex min-w-0 flex-1 items-center justify-center bg-slate-50 px-4 py-6 sm:py-10">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
